import { useObjectTypeDefinitionTranslationOptions } from 'crm-object-board-core/objectTypeDefinition';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H4 } from 'foundations-components/transitional/components/H4';
import { useCallback } from 'react';
import { useLogger } from 'crm-object-board-core/logger';
import { useCloseOverlay } from '../../overlay/OverlayContainer';
import { useTriggerOverlay } from '../../handlers/useTriggerOverlay';
import { FormattedErrorMessage } from './FormattedErrorText';
import { FormattedErrorDescription } from './FormattedErrorDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InvalidStageMoveModal = props => {
  const {
    errorCode,
    objectTypeId,
    objectId
  } = props;
  const logger = useLogger();
  const closeOverlay = useCloseOverlay();
  const handleClick = useCallback(() => {
    closeOverlay();
    logger.log({
      key: 'boardMovePrevented',
      metadata: {
        statusCode: errorCode
      }
    });
  }, [closeOverlay, errorCode, logger]);
  const options = useObjectTypeDefinitionTranslationOptions();
  return /*#__PURE__*/_jsxs(Modal, {
    width: 450,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedErrorMessage, {
          messageRoot: `crmObjectBoard.governance.warningTitle`,
          errorCode: errorCode,
          options: options
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClick
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedErrorDescription, {
        messageRoot: `crmObjectBoard.governance.warningDescription`,
        errorCode: errorCode,
        objectId: objectId,
        objectTypeId: objectTypeId,
        options: options
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.governance.warningButton",
          options: options
        })
      })
    })]
  });
};
export const useOpenInvalidStageMoveModal = () => {
  const trigger = useTriggerOverlay();
  return useCallback(options => {
    const overlay = () => /*#__PURE__*/_jsx(InvalidStageMoveModal, Object.assign({}, options));
    trigger(overlay);
  }, [trigger]);
};